import React from 'react'
import { motion, useScroll, useTransform, useSpring, useReducedMotion } from 'framer-motion'
import Markdown from '@base/parts/markdown'

const Title = (props) => {
  const MotionComponent = motion(props.titleTag)
  const prefersReducedMotion = useReducedMotion()
  const { scrollYProgress } = useScroll({
    target: props.container,
    offset: ["-100vh", "-70vh"]
  })
  const translateY = useSpring(scrollYProgress, {
    stiffness: 50,
    damping: 30
  })
  const titleAnim = useTransform(translateY, [0, 1], [200, 0])
  const titleOpacity = useTransform(translateY, [0, 1], [0, 1])

  if (props.children && props.children !== null) {
    return (
      <motion.div
        style={{
          y: !prefersReducedMotion && titleAnim,
          opacity: titleOpacity
        }}
      >
        <MotionComponent
          className={props.className}
        >
          <Markdown
            children={props.title}
            type="title"
          />
        </MotionComponent>
        {props.children}
      </motion.div>
    )
  }

  return (
    props.title && props.title !== null && (
      <MotionComponent
        style={{
          y: !prefersReducedMotion && titleAnim,
          opacity: titleOpacity
        }}
        className={props.className}
      >
        <Markdown
          children={props.title}
          type="title"
        />
      </MotionComponent>
    )
  )
}

export default Title
